module.exports = __webpack_public_path__ + "static/img/tremolo.046f820.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-1/tremolo.png
// module id = IBw2
// module chunks = 12